module.exports = __webpack_public_path__ + "img/notification - copia.f837cb25.png";